/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopChannelsData } from './TopChannelsData';
import {
    TopChannelsDataFromJSON,
    TopChannelsDataFromJSONTyped,
    TopChannelsDataToJSON,
    TopChannelsDataToJSONTyped,
} from './TopChannelsData';
import type { GoogleAnalyticsDailyMeasurementData } from './GoogleAnalyticsDailyMeasurementData';
import {
    GoogleAnalyticsDailyMeasurementDataFromJSON,
    GoogleAnalyticsDailyMeasurementDataFromJSONTyped,
    GoogleAnalyticsDailyMeasurementDataToJSON,
    GoogleAnalyticsDailyMeasurementDataToJSONTyped,
} from './GoogleAnalyticsDailyMeasurementData';
import type { DailyOverviewData } from './DailyOverviewData';
import {
    DailyOverviewDataFromJSON,
    DailyOverviewDataFromJSONTyped,
    DailyOverviewDataToJSON,
    DailyOverviewDataToJSONTyped,
} from './DailyOverviewData';

/**
 * 
 * @export
 * @interface DailyReportingPeriodData
 */
export interface DailyReportingPeriodData {
    /**
     * 
     * @type {DailyOverviewData}
     * @memberof DailyReportingPeriodData
     */
    orders?: DailyOverviewData;
    /**
     * 
     * @type {TopChannelsData}
     * @memberof DailyReportingPeriodData
     */
    channels?: TopChannelsData;
    /**
     * 
     * @type {Array<GoogleAnalyticsDailyMeasurementData>}
     * @memberof DailyReportingPeriodData
     */
    googleAnalytics?: Array<GoogleAnalyticsDailyMeasurementData>;
}

/**
 * Check if a given object implements the DailyReportingPeriodData interface.
 */
export function instanceOfDailyReportingPeriodData(value: object): value is DailyReportingPeriodData {
    return true;
}

export function DailyReportingPeriodDataFromJSON(json: any): DailyReportingPeriodData {
    return DailyReportingPeriodDataFromJSONTyped(json, false);
}

export function DailyReportingPeriodDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyReportingPeriodData {
    if (json == null) {
        return json;
    }
    return {
        
        'orders': json['orders'] == null ? undefined : DailyOverviewDataFromJSON(json['orders']),
        'channels': json['channels'] == null ? undefined : TopChannelsDataFromJSON(json['channels']),
        'googleAnalytics': json['googleAnalytics'] == null ? undefined : ((json['googleAnalytics'] as Array<any>).map(GoogleAnalyticsDailyMeasurementDataFromJSON)),
    };
}

export function DailyReportingPeriodDataToJSON(json: any): DailyReportingPeriodData {
    return DailyReportingPeriodDataToJSONTyped(json, false);
}

export function DailyReportingPeriodDataToJSONTyped(value?: DailyReportingPeriodData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orders': DailyOverviewDataToJSON(value['orders']),
        'channels': TopChannelsDataToJSON(value['channels']),
        'googleAnalytics': value['googleAnalytics'] == null ? undefined : ((value['googleAnalytics'] as Array<any>).map(GoogleAnalyticsDailyMeasurementDataToJSON)),
    };
}

